import { useState } from "react";
import { Phone, MapPin, Clock, Mail, Send, MessageCircle, Instagram } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CONTACT, waLink, SERVICE_OPTIONS } from "@/data/content";

export const Iletisim = () => {
  const [form, setForm] = useState({ name: "", phone: "", vehicle: "", service: SERVICE_OPTIONS[0], message: "" });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    const text = [
      "Merhaba Sistemli Otomotiv, web sayfanızdan yazıyorum.",
      form.name && `Ad Soyad: ${form.name}`,
      form.phone && `Telefon: ${form.phone}`,
      form.vehicle && `Araç: ${form.vehicle}`,
      form.service && `Hizmet: ${form.service}`,
      form.message && `Mesaj: ${form.message}`,
    ]
      .filter(Boolean)
      .join("\n");
    window.open(waLink(text), "_blank", "noopener,noreferrer");
  };

  const infoCards = [
    {
      id: "phone",
      icon: Phone,
      label: "Telefon",
      value: CONTACT.phoneDisplay,
      href: CONTACT.phoneHref,
      testid: "contact-phone-card",
    },
    {
      id: "whatsapp",
      icon: MessageCircle,
      label: "WhatsApp",
      value: CONTACT.whatsappDisplay,
      href: waLink("Merhaba Sistemli Otomotiv, bilgi ve fiyat almak istiyorum."),
      testid: "contact-whatsapp-card",
    },
    {
      id: "email",
      icon: Mail,
      label: "E-posta",
      value: CONTACT.email,
      href: `mailto:${CONTACT.email}`,
      testid: "contact-email-card",
    },
    {
      id: "instagram",
      icon: Instagram,
      label: "Instagram",
      value: CONTACT.instagramHandle,
      href: CONTACT.instagram,
      testid: "contact-instagram-card",
    },
  ];

  return (
    <section id="iletisim" className="scroll-mt-24 bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand">İletişim</p>
            <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Fiyat teklifi almak 1 dakika sürer
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-slate-600">
              Formu doldurun, mesajınız doğrudan WhatsApp hattımıza iletilsin. İsterseniz tek
              dokunuşla da arayabilirsiniz.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-8 lg:grid-cols-2 lg:gap-10">
          <Reveal>
            <form
              onSubmit={submit}
              data-testid="contact-form"
              className="rounded-3xl border border-slate-200 bg-slate-50 p-6 shadow-soft sm:p-8"
            >
              <div className="grid gap-4 sm:grid-cols-2">
                <label className="block">
                  <span className="text-sm font-bold text-slate-700">Ad Soyad</span>
                  <input
                    type="text"
                    required
                    value={form.name}
                    onChange={set("name")}
                    data-testid="contact-name-input"
                    placeholder="Adınız Soyadınız"
                    className="mt-1.5 w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm outline-none transition-colors placeholder:text-slate-400 focus:border-brand focus:ring-2 focus:ring-brand/20"
                  />
                </label>
                <label className="block">
                  <span className="text-sm font-bold text-slate-700">Telefon</span>
                  <input
                    type="tel"
                    value={form.phone}
                    onChange={set("phone")}
                    data-testid="contact-phone-input"
                    placeholder="05xx xxx xx xx"
                    className="mt-1.5 w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm outline-none transition-colors placeholder:text-slate-400 focus:border-brand focus:ring-2 focus:ring-brand/20"
                  />
                </label>
              </div>

              <label className="mt-4 block">
                <span className="text-sm font-bold text-slate-700">Araç (Marka / Model)</span>
                <input
                  type="text"
                  value={form.vehicle}
                  onChange={set("vehicle")}
                  data-testid="contact-vehicle-input"
                  placeholder="Örn. Fiat Egea 2019"
                  className="mt-1.5 w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm outline-none transition-colors placeholder:text-slate-400 focus:border-brand focus:ring-2 focus:ring-brand/20"
                />
              </label>

              <label className="mt-4 block">
                <span className="text-sm font-bold text-slate-700">Hizmet</span>
                <select
                  value={form.service}
                  onChange={set("service")}
                  data-testid="contact-service-select"
                  className="mt-1.5 w-full appearance-none rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm outline-none transition-colors focus:border-brand focus:ring-2 focus:ring-brand/20"
                >
                  {SERVICE_OPTIONS.map((o) => (
                    <option key={o} value={o}>
                      {o}
                    </option>
                  ))}
                </select>
              </label>

              <label className="mt-4 block">
                <span className="text-sm font-bold text-slate-700">Mesajınız</span>
                <textarea
                  rows="4"
                  value={form.message}
                  onChange={set("message")}
                  data-testid="contact-message-input"
                  placeholder="Aracınızdaki hasarı veya ihtiyacınızı kısaca anlatın..."
                  className="mt-1.5 w-full resize-none rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm outline-none transition-colors placeholder:text-slate-400 focus:border-brand focus:ring-2 focus:ring-brand/20"
                />
              </label>

              <button
                type="submit"
                data-testid="contact-submit-btn"
                className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-whatsapp px-7 py-4 text-base font-bold text-white shadow-soft transition-all hover:-translate-y-0.5 hover:bg-whatsapp-dark hover:shadow-lift"
              >
                <Send className="h-4.5 w-4.5" />
                WhatsApp ile Gönder
              </button>
              <p className="mt-3 text-center text-xs text-slate-500">
                Butona bastığınızda mesajınız WhatsApp uygulamasında hazır gelir, tek dokunuşla
                gönderirsiniz.
              </p>
            </form>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="flex h-full flex-col gap-4">
              <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                {infoCards.map((c) => (
                  <a
                    key={c.id}
                    href={c.href}
                    target={c.id !== "phone" ? "_blank" : undefined}
                    rel={c.id !== "phone" ? "noopener noreferrer" : undefined}
                    data-testid={c.testid}
                    className="group rounded-2xl border border-slate-200 bg-white p-5 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:border-brand/50"
                  >
                    <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-softer text-brand transition-colors group-hover:bg-brand group-hover:text-white">
                      <c.icon className="h-5 w-5" />
                    </span>
                    <p className="mt-4 text-xs font-bold uppercase tracking-wider text-slate-500">
                      {c.label}
                    </p>
                    <p className="mt-1 break-words text-sm font-bold text-slate-900">{c.value}</p>
                  </a>
                ))}
              </div>

              <div
                data-testid="contact-address-card"
                className="flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-6 shadow-soft"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-softer text-brand">
                  <MapPin className="h-5 w-5" />
                </span>
                <div>
                  <p className="text-xs font-bold uppercase tracking-wider text-slate-500">Adres</p>
                  <p className="mt-1 text-sm font-bold leading-relaxed text-slate-900">
                    {CONTACT.address}
                  </p>
                  <a
                    href={CONTACT.mapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="contact-maps-link"
                    className="mt-2 inline-block text-sm font-bold text-brand hover:underline"
                  >
                    Google Maps'te aç →
                  </a>
                </div>
              </div>

              <div
                data-testid="contact-hours-card"
                className="flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-6 shadow-soft"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-softer text-brand">
                  <Clock className="h-5 w-5" />
                </span>
                <div className="w-full">
                  <p className="text-xs font-bold uppercase tracking-wider text-slate-500">
                    Çalışma Saatleri
                  </p>
                  <div className="mt-2 flex flex-col gap-1 text-sm">
                    <div className="flex justify-between">
                      <span className="font-semibold text-slate-700">Pazartesi – Cumartesi</span>
                      <span className="font-bold text-slate-900">08:00 – 19:00</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-semibold text-slate-700">Pazar</span>
                      <span className="font-bold text-slate-900">Kapalı</span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                data-testid="contact-map"
                className="min-h-64 flex-1 overflow-hidden rounded-3xl border border-slate-200 shadow-soft"
              >
                <iframe
                  title="Sistemli Otomotiv konum haritası"
                  src={CONTACT.mapEmbed}
                  loading="lazy"
                  className="h-full min-h-64 w-full border-0"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Iletisim;
